module.exports = __webpack_public_path__ + "img/banner_body-link_01.50a5ccec.svg";